import {
  EVENT_NAME_CAJA_START,
  EVENT_NAME_CONFIRMED_VIEWED,
  EVENT_NAME_EMAIL_UNVERIFIED,
  EVENT_NAME_VIEW_CLASSIFY,
  EVENT_NAME_VIEW_CONCIERGE,
  EVENT_NAME_VIEW_EDIT,
  EVENT_NAME_VIEW_EDIT_PAY_AND_POST,
  EVENT_NAME_VIEW_GUARANTEED_HIRE,
  EVENT_NAME_VIEW_MULTI_LOCATION,
  EVENT_NAME_VIEW_PAY_AND_POST,
  EVENT_NAME_VIEW_REFRESH,
  EVENT_NAME_VIEW_ROLE_REQS,
  EVENT_NAME_VIEW_SELECT_AD,
  EVENT_NAME_VIEW_SUCCESS,
  EVENT_NAME_VIEW_WRITE,
  TEALIUM_PAGE_CONCIERGE,
  TEALIUM_PAGE_EDIT,
  TEALIUM_PAGE_EDIT_PAY_AND_POST,
  TEALIUM_PAGE_GUARANTEED_HIRE,
  TEALIUM_PAGE_MULTI_LOCATION,
  TEALIUM_PAGE_PAY_AND_POST,
  TEALIUM_PAGE_REFRESH,
  TEALIUM_PAGE_ROLE_REQS,
  TEALIUM_PAGE_SELECT_AD,
  TEALIUM_PAGE_SUCCESS,
  TEALIUM_PAGE_WRITE,
} from 'src/app/analytics';
import { IS_ON_CREDIT_HOLD_IMPRESSION } from 'src/app/constants/tealium';
import { store } from 'src/app/state/store';
import { setPageViewEvent } from 'src/app/utils/analytics/utils/checkPageViewEvent';
import type AppState from 'src/types/appState';

import { getViewEventData } from './utils/getViewEventDataByPage';
import sendUtagViewEvent from './utils/sendUtagViewEvent';
const getTealiumPageEvent = (page: string): string => {
  switch (page) {
    case TEALIUM_PAGE_WRITE:
      return EVENT_NAME_VIEW_WRITE;
    case TEALIUM_PAGE_SELECT_AD:
      return EVENT_NAME_VIEW_SELECT_AD;
    case TEALIUM_PAGE_CONCIERGE:
      return EVENT_NAME_VIEW_CONCIERGE;
    case TEALIUM_PAGE_GUARANTEED_HIRE:
      return EVENT_NAME_VIEW_GUARANTEED_HIRE;
    case TEALIUM_PAGE_MULTI_LOCATION:
      return EVENT_NAME_VIEW_MULTI_LOCATION;
    case TEALIUM_PAGE_ROLE_REQS:
      return EVENT_NAME_VIEW_ROLE_REQS;
    case TEALIUM_PAGE_PAY_AND_POST:
      return EVENT_NAME_VIEW_PAY_AND_POST;
    case TEALIUM_PAGE_SUCCESS:
      return EVENT_NAME_VIEW_SUCCESS;
    default:
      return EVENT_NAME_VIEW_CLASSIFY;
  }
};

const eventNameMap = {
  [TEALIUM_PAGE_EDIT]: EVENT_NAME_VIEW_EDIT,
  [TEALIUM_PAGE_REFRESH]: EVENT_NAME_VIEW_REFRESH,
  [TEALIUM_PAGE_EDIT_PAY_AND_POST]: EVENT_NAME_VIEW_EDIT_PAY_AND_POST,
} as Record<string, string>;

const isEditOrRefreshFlow = (page: string) =>
  page === TEALIUM_PAGE_EDIT ||
  page === TEALIUM_PAGE_EDIT_PAY_AND_POST ||
  page === TEALIUM_PAGE_REFRESH;

export default () => {
  const { tealium }: AppState = store.getState();
  const eventData = getViewEventData(tealium);

  if (isEditOrRefreshFlow(tealium.page)) {
    return sendUtagViewEvent(eventNameMap[tealium.page], eventData);
  }

  const {
    adBudgetPurchased,
    emailAddressVerified,
    hirerPurchaseType,
    hirerAdPurchaser,
    isOnCreditHold,
    jobAdPostedWithRR,
    page,
    previousPageName,
  } = tealium;

  if (page) {
    const eventName = [
      hirerPurchaseType,
      hirerAdPurchaser,
      getTealiumPageEvent(page),
    ];

    if (!emailAddressVerified) {
      eventName.push(EVENT_NAME_EMAIL_UNVERIFIED);
    }

    if (page === TEALIUM_PAGE_PAY_AND_POST && isOnCreditHold) {
      eventName.push(IS_ON_CREDIT_HOLD_IMPRESSION);
    }

    if (page === TEALIUM_PAGE_SUCCESS) {
      eventName.push(EVENT_NAME_CONFIRMED_VIEWED);
      eventName.push('ad-premium-offered');
      eventName.push('job-ad-completed');
      eventName.push(`${hirerAdPurchaser}`);
      eventName.push(`${hirerPurchaseType}`);
      eventName.push(`${adBudgetPurchased}`);

      if (jobAdPostedWithRR) {
        eventName.push(jobAdPostedWithRR);
      }
    }

    if (!previousPageName) {
      eventName.push(EVENT_NAME_CAJA_START);
    }

    if (page === TEALIUM_PAGE_SUCCESS) {
      setPageViewEvent(eventData.seekListingId);
    }

    sendUtagViewEvent(eventName, eventData);
  }
};
